import { render, staticRenderFns } from "./TestInsuranceForm.vue?vue&type=template&id=2e563ca8"
import script from "./TestInsuranceForm.vue?vue&type=script&lang=js"
export * from "./TestInsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports